
















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { StepMixin, StepStoreMixin } from '@mixin';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            store: {
                crowdfunding: null,
            },
            next: false,
        };
    },

    mixins: [
        StepMixin,
        StepStoreMixin
    ],

    methods: {
        click(crowdfunding) {
            this.store.crowdfunding = crowdfunding;

            if (!crowdfunding) {
                this.$router.push({ 
                    path: `/apply/${ this.projectId }/project/declined`,
                    query: { declined: true }
                });
            } else {
                this.$router.push(`/apply/${ this.projectId }/project/projectplan`);
            }
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Crowdfunding extends Vue {}

